import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { About } from '../components/sections/About';
import { ExperienceDirectory } from '../components/sections/ExperienceDirectory';
import { Skills } from '../components/sections/Skills';
import { ImpactMetrics } from '../components/sections/ImpactMetrics';
import { ValueProposition } from '../components/sections/ValueProposition';
import { CareerTrack } from '../components/sections/CareerTrack';
import { TechnicalMastery } from '../components/sections/TechnicalMastery';
import { BoardCredentials } from '../components/sections/BoardCredentials';
interface HomeLocationState {
  scrollTo?: string;
}
export function Home() {
  const location = useLocation();
  const state = location.state as HomeLocationState | null;
  useEffect(() => {
    if (!state?.scrollTo) return;
    const target = document.getElementById(state.scrollTo);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [state?.scrollTo]);
  return <main data-id="element-171" data-mp="30uf948u15x54">
      <Hero data-id="element-172" data-mp="2vxottnq1v5kr" />
      <About data-id="element-173" data-mp="2vx6rc9csnv4e" />
      <ExperienceDirectory data-id="element-174" data-mp="2vxf13sdmekbd" />
      <Skills data-id="element-175" data-mp="2vy85imp3wxqc" />
      <ImpactMetrics data-id="element-176" data-mp="2vvlugd30c03d" />
      <ValueProposition data-id="element-177" data-mp="2qylrwc5d9fh0" />
      <CareerTrack data-id="element-178" data-mp="2qxu43ni0gm1a" />
      <TechnicalMastery data-id="element-179" data-mp="2qxaowejqwbqy" />
      <BoardCredentials data-id="element-180" data-mp="2r0ondbpag0t4" />
    </main>;
}